













import { defineComponent } from "@vue/composition-api";
import BaseButton from "@/components/BaseButton";
import BasePage from "@/components/BasePage";
import BaseTitle from "@/components/BaseTitle";
import FooterPolicy from "@/components/FooterPolicy";

export default defineComponent({
  name: "PageLanding",
  components: { FooterPolicy, BasePage, BaseTitle, BaseButton },
  created() {
    this.$router.replace({ name: "home" });
  },
});
